"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyRatesSchema = void 0;
const zod_1 = require("zod");
exports.currencyRatesSchema = zod_1.z.object({
    date: zod_1.z.string(),
    base: zod_1.z.string(),
    rates: zod_1.z.record(zod_1.z.number()),
});
